// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"527":"4f1ef51e","701":"31acd60d","908":"31acd60d","973":"2d56368f","974":"31acd60d"}[chunkId] + ".css";
};